import { api } from '@/lib/api';

export function backupRemotoQueryOptions(servicoId: number) {
  return api.queryOptions('get', '/clientes/hibridos/{id}/backups-remotos', {
    params: { path: { id: servicoId } },
  });
}
